import React from "react";
import icons from "components/UI/icons/icons";
import Marquee from "react-fast-marquee";

type EventType = {
    isHidden: boolean
}

const Event: React.FC<EventType> = (
    {
        isHidden,
    }
) => {
    const {IconArrow} = icons;

    return (
        <div className={`event event-voting-started  ${isHidden ? "event--show": ""}`}>
            <Marquee speed={100} pauseOnHover={true} gradient={false}>
                <div className="event__wrapper">
                <div className="event__container">
                <div className="event__block">
                    <p className="event__text">
                        <span className="text-bold">Iggy Dance & DJ Challenge is finished on July 2022 </span>
                    </p>
                    <a target="_blank" href="https://challenge.1ath.studio/season1/voting"
                        className="event__btn event__btn--primary">
                        Final Results
                    </a>
                </div>
                <div className="event__block">
                    <p className="event__text">
                        <span className="text-bold">Iggy Dance & DJ Challenge is finished on July 2022 </span>
                    </p>
                    <a target="_blank" href="https://challenge.1ath.studio/season1/voting"
                        className="event__btn event__btn--primary">
                        Final Results
                    </a>
                </div> <div className="event__block">
                    <p className="event__text">
                        <span className="text-bold">Iggy Dance & DJ Challenge is finished on July 2022 </span>
                    </p>
                    <a target="_blank" href="https://challenge.1ath.studio/season1/voting"
                        className="event__btn event__btn--primary">
                        Final Results
                    </a>
                </div> <div className="event__block">
                    <p className="event__text">
                        <span className="text-bold">Iggy Dance & DJ Challenge is finished on July 2022 </span>
                    </p>
                    <a target="_blank" href="https://challenge.1ath.studio/season1/voting"
                        className="event__btn event__btn--primary">
                        Final Results
                    </a>
                </div>
            </div>
                </div>
            </Marquee>
        </div>
    );
};

export default Event;